export default {"src":"/_next/static/media/walking-bridge-lg.mono.37c7e178.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};